import React from 'react';
import { injectV2 } from '../../../../injectV2';
import { WidgetFeature } from '../WidgetFeatureList/WidgetFeatureList';
import { UiLoggerStore, WidgetClickedElement } from '../../../../stores/UiLoggerStore';
import { WidgetFeatureCarousel } from '../WidgetFeatureCarousel/WidgetFeatureCarousel';
import { WidgetFeatureHeader } from '../WidgetFeatureHeader/WidgetFeatureHeader';
import { usePrevious } from '../../../../hooks/usePrevious';
import { widgetFeatureDetailsDataHooks } from './WidgetFeatureDetails.dataHooks';

interface WidgetFeatureDetailsProps {
  features: WidgetFeature[];
  selectedFeature: WidgetFeature;
  selectFeature: (feature: WidgetFeature | null) => void;
  dataHook?: string;
  uiLoggerStore: UiLoggerStore;
}

const WidgetFeatureDetailsCmp = (props: WidgetFeatureDetailsProps) => {
  const { selectedFeature, selectFeature, features, uiLoggerStore, dataHook } = props;
  const selectedFeatureIndex = features.findIndex((feature) => feature === selectedFeature);
  const previousSelectedFeatureIndex = usePrevious<number>(selectedFeatureIndex);
  const currentToolIndex = features.findIndex((feature) => feature === selectedFeature);
  const isCarouselSlidingBackward = previousSelectedFeatureIndex > selectedFeatureIndex;

  const createElementClickHandler = (elementName: WidgetClickedElement) => (event: React.MouseEvent) => {
    event.stopPropagation();
    uiLoggerStore.logWidgetActions(elementName, currentToolIndex);
  };

  const createSelectFeatureHandler = (
    elementName: WidgetClickedElement,
    feature: WidgetFeature | null,
    selectedToolIndex?: number,
  ) => (event: React.MouseEvent) => {
    event.stopPropagation();
    uiLoggerStore.logWidgetActions(elementName, currentToolIndex, selectedToolIndex);
    selectFeature(feature);
  };

  return (
    <div data-hook={dataHook}>
      <WidgetFeatureHeader
        dataHook={widgetFeatureDetailsDataHooks.header()}
        selectedFeature={selectedFeature}
        createSelectFeatureHandler={createSelectFeatureHandler}
        features={features}
      />
      <WidgetFeatureCarousel
        dataHook={widgetFeatureDetailsDataHooks.carousel()}
        selectedFeature={selectedFeature}
        createElementClickHandler={createElementClickHandler}
        isSlidingBackward={isCarouselSlidingBackward}
      />
    </div>
  );
};

export const WidgetFeatureDetails = injectV2('uiLoggerStore')(WidgetFeatureDetailsCmp);
